// @ts-nocheck
import React, { Component } from 'react'
import PropTypes from 'prop-types'

class InputRange extends Component {
  constructor (props) {
    super(props)

    this.state = {
      step: this.props.stepJump || 2000,
      value: 0
    }

    this.Addition = this.Addition.bind(this)
    this.Subtraction = this.Subtraction.bind(this)
    this.OnChangeInputHandle = this.OnChangeInputHandle.bind(this)
    this.OnBlurInputHandle = this.OnBlurInputHandle.bind(this)
  }

  ConvertPointsToCurrency (points) {
    const CustomResponse = (points, value) => ({
      points,
      value
    })

    if (!this.props.equivalence) {
      return { error: 'equivalence não configurado para o campo' }
    }

    if (this.props.isDivisible) {
      if (!this.props.multipliceRule) {
        return { error: 'multipliceRule não configurado para o campo' }
      }

      if (!(points % this.props.multipliceRule !== 0)) {
        return CustomResponse(points, points / this.props.equivalence)
      } else {
        this.setState({ value: this.props.minimunValue })
        return CustomResponse(
          this.props.minimunValue,
          this.props.minimunValue / this.props.equivalence
        )
      }
    } else {
      return points * this.props.equivalence
    }
  }

  Addition () {
    const value = parseInt(this.state.value) + parseInt(this.state.step)

    this.setState({ value })

    console.log(value)

    this.CallbackPointsToComponent(value)
  }

  Subtraction () {
    const valueModel = parseInt(this.state.value) - parseInt(this.state.step)
    const value = valueModel > 0 ? valueModel : parseInt(this.props.minimunValue)

    this.setState({ value })

    this.CallbackPointsToComponent(value)
  }

  // #region ["Event Listiners"]

  OnChangeInputHandle = e => this.setState({ value: parseInt(e.target.value) })

  OnBlurInputHandle = () => this.CallbackPointsToComponent(this.state.value)

  CallbackPointsToComponent (value) {
    const currency = this.ConvertPointsToCurrency(value)

    const { error } = currency

    this.props.handlerValueSelected({
      totalPoints: currency.points,
      totalCurrency: error || currency.value
    })
  }

  // #endregion

  render () {
    return (
      <div className='form-field px-0 stix-quantity form-field'>
        <input
          type='number'
          id='qtd-points'
          className='input-spinner-vertical no-label'
          placeholder='Quantidade'
          aria-label='Quantidade'
          disabled={this.props.disabled}
          min={this.props.minimunValue}
          max={this.props.maximunValue}
          value={this.state.value}
          step={this.state.step}
          onChange={this.OnChangeInputHandle}
          onBlur={this.OnBlurInputHandle}
        />
        <div
          className='quantity-button icon icon_more quantity-up'
          onClick={this.Addition}
        />
        <div
          className='quantity-button icon icon_remove quantity-down'
          onClick={this.Subtraction}
        />
      </div>
    )
  }
}

InputRange.propTypes = {
  minimunValue: PropTypes.number,
  maximunValue: PropTypes.number,
  multipliceRule: PropTypes.number,
  equivalence: PropTypes.number,
  stepJump: PropTypes.number,
  handlerValueSelected: PropTypes.func,
  isDivisible: PropTypes.bool,
  disabled: PropTypes.bool
}

export default InputRange



// WEBPACK FOOTER //
// ./src/features/Stix/InputRange.js